/* eslint-disable eslint-comments/disable-enable-pair, security/detect-object-injection */
import {
  SET_SLIDES, GO_TO_SLIDE, NEXT_SLIDE, SET_OFFER_COUNTER, SET_SLIDER_IMAGES
} from 'src/redux/actions/slider';


const initialState = {
  slides: [],
  active: 0
};

const nextSlide = (state) => {
  const featureCurrent = state.active + 1;
  const sliderLength = state.slides.length;
  const newActive = featureCurrent >= sliderLength ? 0 : featureCurrent;

  return {
    ...state,
    active: newActive
  };
};

const plural = number =>
  // eslint-disable-next-line no-magic-numbers,no-bitwise, implicit-arrow-linebreak
  (number % 10 < 5) && (number % 10 > 1) && ((~~(number / 10) % 10) !== 1);

const offersCountText = (count, labels) => {
  if (count) {
    if (count === 1) {
      return `${count.toLocaleString('pl-PL')} ${labels.one}`;
    }

    if (plural(count)) {
      return `${count.toLocaleString('pl-PL')} ${labels.few}`;
    }

    return `${count.toLocaleString('pl-PL')} ${labels.many}`;
  }

  return labels.zero;
};

const setOfferCounter = (state, payload) => ({
  ...state,
  slides: state.slides.map((slide) => {
    const offerCounter = slide.offerCounter.includes('{counter}')
      ? slide.offerCounter.replace('{counter}', offersCountText(payload.count, slide.afterCounterText))
      : slide.offerCounter;
    return {
      ...slide,
      offerCounter
    };
  })
});

const setSliderImages = (state, sliderImages) => ({
  ...state,
  slides: state.slides.map(slide => ({
    ...slide,
    imgUrl: slide.imgUrl.map(imgUrl => ({ ...imgUrl, url: sliderImages[slide.id][imgUrl.key] }))
  }))

});

const sliderReducer = (state = initialState, { type, payload }) => ({
  [SET_SLIDES]: () => ({ ...state, ...payload }),
  [SET_OFFER_COUNTER]: setOfferCounter,
  [GO_TO_SLIDE]: () => ({ ...state, ...payload }),
  [NEXT_SLIDE]: nextSlide,
  [SET_SLIDER_IMAGES]: setSliderImages
}[type] || (() => state))(state, payload);

export default sliderReducer;
